import loansQuery from '../graphql/queries/loans'
import myClosedLoansQuery from '../graphql/queries/myClosedLoans'
import myDebtsQuery from '../graphql/queries/myDebts'
import myLoansQuery from '../graphql/queries/myLoans'

export const loanQueries = admin => [
  {
    query: myClosedLoansQuery
  },
  ...(admin
    ? [
        {
          query: loansQuery
        },
        {
          query: loansQuery,
          variables: {
            closed: true
          }
        },
        {
          query: loansQuery,
          variables: {
            closed: false
          }
        }
      ]
    : []),
  {
    query: myDebtsQuery
  },
  {
    query: myLoansQuery
  }
]



// WEBPACK FOOTER //
// ./src/utils/refetchQueries.tsx